import { render, staticRenderFns } from "./detailContent.vue?vue&type=template&id=7879cba5&"
import script from "./detailContent.vue?vue&type=script&lang=js&"
export * from "./detailContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports